import React, { useCallback, useState } from 'react';
import { V3OfferProvider } from '../contexts/V3OfferContext';
import SimpleOfferLayout from '../components/simple/SimpleOfferLayout';
import V3NewOfferFTUXModal from '../components/V3NewOfferFTUXModal';

const SimpleOfferEditApp = (props) => {
  // The Template tile's "Change template…" opens this picker (via
  // openFtuxModal). It applies the chosen template server-side and reloads,
  // so it only needs to be mounted and wired to the open state.
  const [ftuxOpen, setFtuxOpen] = useState(false);
  // Which act the modal was opened FOR. Selecting a sibling switches acts in
  // context without a reload, so props.offer stays whichever the server rendered
  // — and the modal, which branches on isPrimaryOffer, would offer a support the
  // event-template pane that rewrites the whole show's budget with no confirm.
  const [ftuxOffer, setFtuxOffer] = useState(props.offer);
  // Which pane to land on, when the caller means a specific one — the template
  // bar's "Browse blueprints" is a solo show's only route back to the blueprint
  // library once this modal has been dismissed.
  const [ftuxNav, setFtuxNav] = useState(null);
  const openFtuxModal = useCallback((offer, options = {}) => {
    setFtuxOffer(offer || props.offer);
    setFtuxNav(options.nav || null);
    setFtuxOpen(true);
  }, [props.offer]);
  const closeFtuxModal = useCallback(() => setFtuxOpen(false), []);

  return (
    <V3OfferProvider
      csrfToken={props.csrfToken}
      team={props.team}
      currentUser={props.currentUser}
      initialOffer={props.offer}
      initialBudget={props.budget}
      initialLineItems={props.lineItems}
      eventOffers={props.eventOffers}
      confirm={props.confirm}
      entryOrigin={props.entryOrigin}
      changelogVersions={props.changelogVersions}
      lastEditedAt={props.lastEditedAt}
      editorVariant="v3_simple"
      openFtuxModal={openFtuxModal}
    >
      <SimpleOfferLayout />
      <V3NewOfferFTUXModal
        open={ftuxOpen}
        onClose={closeFtuxModal}
        team={props.team}
        offer={ftuxOffer || props.offer}
        csrfToken={props.csrfToken}
        initialNav={ftuxNav}
      />
    </V3OfferProvider>
  );
};

export default SimpleOfferEditApp;
